import Screen from '../../../../shared/utils/screen';
import styled from 'styled-components';

const AccessTextBlockContainer = styled.div<React.CSSProperties>`
  position: absolute;
  top: ${345 * Screen.widthRatio}px;
  left: ${108 * Screen.widthRatio}px;
  width: ${830 * Screen.widthRatio}px;
`;

export default AccessTextBlockContainer;
